import _ from "lodash";
import smoothscroll from "smoothscroll-polyfill";
import imagesLoaded from "imagesloaded";
import yall from "yall-js";

smoothscroll.polyfill();

import { handleWords } from "./modules/handleWords";
import { handleSlideshowContainer } from "./modules/handleSlideshow";
import { handleLoader } from "./modules/loader";
import {
  handleMenuStripes,
  handleMenuItems,
  handleMenuScrollAnimations,
} from "./modules/handleMenu";
import { removeBlur, setImageSize } from "./modules/handleLazyImages";
import { handleForm } from "./modules/handleForm";
import { setBreakPoints } from "./modules/handleBreakpoints";

const yall_options = {
  threshold: window.innerHeight * 2,
  idleLoadTimeout: 0,
  events: {
    load: function(event) {
      if (
        !event.target.classList.contains("lazy") &&
        event.target.nodeName == "IMG"
      ) {
        imagesLoaded(event.target, removeBlur);
      }
    },
  },
};

const removeHovers = function() {
  const hovers = Array.from(document.querySelectorAll(".project-list--hover"));
  if (hovers !== null) {
    hovers.forEach((hover) => hover.remove());
  }
};

const handleBodyLoad = function() {
  const phone = "ontouchstart" in window;
  setImageSize();
  setBreakPoints();
  yall(yall_options);
  //get all Eleemnts
  const menuContainer = document.querySelector("#menu_container");
  const menuStripes = document.querySelector(".menu_stripes");
  const menuHomeLink = document.querySelector(".home_link");
  const menu = document.querySelector(".menu");
  const menuList = document.querySelector(".menu_list");
  const mainContainer = document.getElementById("main-container");
  const wordsItems = Array.from(document.querySelectorAll(".words-item"));
  const menuItems = Array.from(document.querySelectorAll(".menu_item"));
  const loaderContainer = document.getElementById("loader-container");
  const loaderBar = document.getElementById("loader_bar");
  const logoLoad = document.getElementById("logoLoad");
  const logoHome = document.getElementById("logoHome");
  const logoArrow = document.getElementById("logoArrow");
  const slideShowContainer = document.getElementById("slideshow_container");
  const scroller = document.getElementById("scroller");

  const loaderArgs = {
    loaderContainer,
    loaderBar,
    mainContainer,
    menuContainer,
    logoLoad,
    logoHome,
    logoArrow,
    slideShowContainer,
    scroller,
  };
  handleLoader(loaderArgs);

  if (menuItems !== null) {
    const menuClickArgs = {
      menuStripes,
      menu,
      menuList,
      mainContainer,
      menuItems,
      logoLoad,
      logoHome,
      logoArrow,
    };
    handleMenuItems(menuItems, menuClickArgs);
  }

  if (wordsItems !== null) {
    handleWords(wordsItems, wordsItems.length);
  }

  if (menuStripes && menu && menuList && mainContainer && menuItems) {
    const menuStripesArgs = {
      menuStripes,
      menu,
      menuList,
      mainContainer,
      menuItems,
      logoLoad,
      logoHome,
      logoArrow,
    };

    handleMenuStripes(menuStripes, menuStripesArgs);
  }

  if (menuHomeLink && menuStripes) {
    handleMenuScrollAnimations(menuStripes, menuHomeLink);
  }

  if (slideShowContainer) {
    handleSlideshowContainer(slideShowContainer, phone);
  }

  if (phone) {
    removeHovers();
  }

  handleForm();
};

export const init = () => {
  window.addEventListener("DOMContentLoaded", handleBodyLoad);
  window.addEventListener("resize", setImageSize);
  window.addEventListener("unload", () => {
    const mainContainer = document.getElementById("main-container");
    mainContainer.style.opacity = 0;
    document.documentElement.scrollTop = 0;
  });
};
